<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="chartOptions"
  class="highcharts-light block w-full h-full"
  (chartInstance)="setChart($event)">
</highcharts-chart>

